import { Component, OnDestroy } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'mpro-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', './../login-common.scss'],
})
export class LoginComponent implements OnDestroy {
  public faEye = faEye;
  public form: UntypedFormGroup;
  public errorMsg;
  public passwordType: 'password' | 'text' = 'password';

  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }

    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  public login() {
    this.errorMsg = '';
    if (!this.form.valid) {
      return;
    }

    this.authService
      .login(this.form.value.username, this.form.value.password)
      .pipe(takeUntil(this.ngUnsubscribe), first())
      .subscribe(
        (_) => this.router.navigate(['/']),
        (err: HttpErrorResponse) => {
          if (err.error && typeof err.error.message === 'string') {
            this.errorMsg = err.error.message;
          } else {
            this.errorMsg = 'An unexpected error occurred. Please try again.';
          }
        }
      );
  }

  public setPasswordType() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
